export { ConfirmedOrderCard } from '@src/features/orders/confirmed-order/components/ConfirmedOrderCard';
export type { ConfirmedOrderCardProps } from '@src/features/orders/confirmed-order/components/ConfirmedOrderCard';
export { useConfirmedOrder } from '@src/features/orders/confirmed-order/hooks/useConfirmedOrder';
